export default __webpack_public_path__ + "static/media/escalator-up.inline.39f2d303.svg";